import Position from '../helpers/Position';
import General from '../helpers/General';
import Stats from '../helpers/Stats';
const $_element = document.querySelector('.nav-main');

export default class Nav {
  constructor() {
    this.listenerOpenTab = false;
    this.state = 'close';
    this.mobileLevel3PendingByScope = new WeakMap();
    this.mobileNavV2TrackingBound = false;
    this.mobileNavV2GeneralTrackingBound = false;

    this.setNavLoclStorage();
    this.disableLegacyMobileHamburgerTrackingForV2();

    this.toggleNav();
    this.toggleNavSpecial();
    this.handleClickCloseButton();
    this.handleClickWrapper();

    this.initialEvents();

    if (window.nav_progressbar !== undefined) {
      this.progressBarMobileSiteNav();
    }

    this.bindViewEvents();
    this.bindMobileNewNavHeader();
    this.bindKeyboardDropdown();
    this.bindKeyboardSiteNavLinks();
    this.bindMobileNavV2GeneralTracking();
    this.bindMobileNavV2Tracking();
  }

  initialEvents() {
    const event_links = document.querySelectorAll('.header-event-link');
    event_links.forEach((event_link) => {
      event_link.addEventListener('click', (e) => {
        const link = e.currentTarget;
        let type = link.dataset.navType;
        const title = link.getAttribute('title');
        const nav = link.dataset.navMode;

        if (
          nav === 'Old' &&
          type === 'Desktop Link' &&
          window.matchMedia('(max-width: 1023.98px)').matches
        ) {
          type = 'Hot Bar Link';
        }
        this.sendStats(
          'send',
          'event',
          `${nav} Navigation`,
          'Click',
          `${type} ${title}`
        );
      });
    });
  }

  sendStats() {
    if (window.ga) {
      ga(arguments);
    }
  }

  isNewNavV2Active() {
    return document.documentElement.classList.contains('new-nav-enabled');
  }

  isDesktopSidebarNavActive() {
    const isMobileViewport = window.matchMedia
      ? window.matchMedia('(max-width: 1023.98px)').matches
      : window.innerWidth < 1024;

    return (
      !isMobileViewport &&
      document.documentElement.classList.contains(
        'new-nav-desktop-sidebar-enabled'
      )
    );
  }

  getMobileNavV2TrackingPrefix() {
    return document.documentElement.classList.contains(
      'new-nav-desktop-sidebar-enabled'
    )
      ? 'desktop-mobile-nav-v2'
      : 'mobile-nav-v2';
  }

  buildMobileNavV2Category(suffix = '') {
    return this.buildTrackingLabel([this.getMobileNavV2TrackingPrefix(), suffix], '__');
  }

  buildMobileNavV2EventLabel(suffix = '') {
    return this.buildMobileNavV2Category(suffix);
  }

  disableLegacyMobileHamburgerTrackingForV2() {
    if (!this.isNewNavV2Active()) {
      return;
    }

    document
      .querySelectorAll('.nav-main__toggle-btn--open, .nav-main__toggle-btn--close')
      .forEach((toggleButton) => {
        toggleButton.classList.remove('gld-gtag-event--click');
        toggleButton.removeAttribute('data-gtag-data');
      });
  }

  normalizeTrackingValue(value = '') {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  buildTrackingLabel(parts = [], delimiter = '_') {
    return parts
      .map((part) => this.normalizeTrackingValue(part))
      .filter((part) => part.length > 0)
      .join(delimiter);
  }

  sendTrackingEvent(event_category, event_label = '') {
    if (!event_category) {
      return;
    }

    const payload = { event_category };
    const normalizedLabel = this.normalizeTrackingValue(event_label);
    if (normalizedLabel) {
      payload.event_label = normalizedLabel;
    }

    Stats.sendEventDataLayerViaShopify(payload);
  }

  getElementHrefValue(element) {
    if (!element || typeof element.getAttribute !== 'function') {
      return '';
    }

    return this.normalizeTrackingValue(element.getAttribute('href') || '');
  }

  getFirstChildWithoutClasses(element, excludedClassNames = []) {
    if (!element || !element.children) {
      return null;
    }

    return (
      [...element.children].find((child) => {
        if (!child.classList) {
          return true;
        }

        return !excludedClassNames.some((className) =>
          child.classList.contains(className)
        );
      }) || null
    );
  }

  getMobileLinkValue(link) {
    if (!link) {
      return '';
    }

    const labelChild = this.getFirstChildWithoutClasses(link, [
      'main-menu-mobile-nav__icon',
      'main-menu-mobile-nav__badge',
      'main-menu-mobile-nav__arrow',
      'main-menu-mobile-nav__back-icon',
    ]);

    if (labelChild) {
      return this.normalizeTrackingValue(labelChild.textContent);
    }

    return this.normalizeTrackingValue(link.textContent);
  }

  getMobileSubviewTrackingContext(element) {
    const subview = element?.closest('.js-mm-mobile-dy-subview');
    if (!subview) {
      return {
        level: null,
        parentLevel1: '',
        parentLevel2: '',
      };
    }

    const title = this.normalizeTrackingValue(
      subview.querySelector('.main-menu-mobile-nav__title')?.textContent || ''
    );

    const backButton = subview.querySelector('.js-mm-mobile-dy-link-back');
    const backLevel = parseInt(backButton?.dataset?.level || '', 10);
    const backSpans = backButton ? [...backButton.querySelectorAll('span')] : [];
    const backLabel = this.normalizeTrackingValue(
      backSpans[backSpans.length - 1]?.textContent ||
        backButton?.getAttribute('title') ||
        ''
    );

    if (backLevel === 3) {
      return {
        level: 3,
        parentLevel1: backLabel,
        parentLevel2: title,
      };
    }

    return {
      level: 2,
      parentLevel1: title,
      parentLevel2: '',
    };
  }

  getMobileBlockValue(blockLink) {
    if (!blockLink) {
      return '';
    }

    const imageTitle = blockLink.querySelector(
      '.main-menu-mobile-nav__level2-image-title-inner'
    );
    if (imageTitle) {
      return this.normalizeTrackingValue(imageTitle.textContent);
    }

    const textValue = this.normalizeTrackingValue(blockLink.textContent);
    if (textValue) {
      return textValue;
    }

    return this.normalizeTrackingValue(
      blockLink.querySelector('img')?.getAttribute('alt') || ''
    );
  }

  bindMobileNavV2Tracking() {
    if (this.mobileNavV2TrackingBound) {
      return;
    }

    this.mobileNavV2TrackingBound = true;

    document.addEventListener(
      'click',
      (event) => {
        if (!this.isNewNavV2Active()) {
          return;
        }

        const trigger = event.target?.closest?.('a, button');
        if (!trigger) {
          return;
        }

        const mobileContainer = trigger.closest('.main-menu-mobile-nav-container');
        if (!mobileContainer) {
          return;
        }

        const backLink = trigger.closest('.js-mm-mobile-dy-link-back');
        if (backLink) {
          const labelSpans = [...backLink.querySelectorAll('span')];
          const backlinkValue = this.normalizeTrackingValue(
            labelSpans[labelSpans.length - 1]?.textContent ||
              backLink.getAttribute('title') ||
              ''
          );
          this.sendTrackingEvent(
            this.buildMobileNavV2Category('backlink'),
            backlinkValue
          );
          return;
        }

        const footerLink = trigger.closest('.main-menu-mobile-nav__footer-link');
        if (footerLink) {
          const value = this.normalizeTrackingValue(footerLink.textContent);
          const href = this.getElementHrefValue(footerLink);
          this.sendTrackingEvent(
            this.buildMobileNavV2Category('level1__footer'),
            this.buildTrackingLabel([value, href])
          );
          return;
        }

        const carouselCard = trigger.closest('.main-menu-mobile-carousel__card');
        if (carouselCard) {
          const carouselIndex =
            carouselCard.closest('.main-menu-mobile-carousel')?.dataset
              ?.carouselIndex || '1';
          const value = this.normalizeTrackingValue(
            carouselCard.querySelector('.main-menu-mobile-carousel__card-title')
              ?.textContent ||
              carouselCard.querySelector('img')?.getAttribute('alt') ||
              ''
          );
          const href = this.getElementHrefValue(carouselCard);
          this.sendTrackingEvent(
            this.buildMobileNavV2Category(`level1__slider${carouselIndex}`),
            this.buildTrackingLabel([value, href])
          );
          return;
        }

        const blockLink = trigger.closest(
          '.main-menu-mobile-nav__level2-image-card, .main-menu-mobile-nav__icon-grid-card'
        );
        if (blockLink) {
          const value = this.getMobileBlockValue(blockLink);
          const { level, parentLevel1, parentLevel2 } =
            this.getMobileSubviewTrackingContext(blockLink);

          if (level === 3) {
            this.sendTrackingEvent(
              this.buildMobileNavV2Category('level3__block'),
              this.buildTrackingLabel([parentLevel1, parentLevel2, value])
            );
          } else {
            this.sendTrackingEvent(
              this.buildMobileNavV2Category('level2__block'),
              this.buildTrackingLabel([parentLevel1, value])
            );
          }
          return;
        }

        const navLink = trigger.closest('.main-menu-mobile-nav__link');
        if (!navLink) {
          return;
        }

        const level = parseInt(navLink.dataset.level || '1', 10);
        const value = this.getMobileLinkValue(navLink);
        const isToggle = navLink.classList.contains('js-mm-mobile-dy-link-view');
        const { parentLevel1, parentLevel2 } =
          this.getMobileSubviewTrackingContext(navLink);

        if (level === 1) {
          this.sendTrackingEvent(
            isToggle
              ? this.buildMobileNavV2Category('level1__toggle')
              : this.buildMobileNavV2Category('level1__item'),
            value
          );
          return;
        }

        if (level === 2) {
          this.sendTrackingEvent(
            isToggle
              ? this.buildMobileNavV2Category('level2__toggle')
              : this.buildMobileNavV2Category('level2__item'),
            this.buildTrackingLabel([parentLevel1, value])
          );
          return;
        }

        this.sendTrackingEvent(
          this.buildMobileNavV2Category('level3__item'),
          this.buildTrackingLabel([parentLevel1, parentLevel2, value])
        );
      },
      true
    );
  }

  bindMobileNavV2GeneralTracking() {
    if (this.mobileNavV2GeneralTrackingBound) {
      return;
    }

    this.mobileNavV2GeneralTrackingBound = true;

    document.addEventListener(
      'focusin',
      (event) => {
        if (!this.isNewNavV2Active()) {
          return;
        }

        const searchInput = event.target?.closest?.('.js-mm-mobile-new-search-input');
        if (!searchInput) {
          return;
        }

        const mobileContainer = searchInput.closest('.main-menu-mobile-nav-container');
        if (!mobileContainer) {
          return;
        }

        this.sendTrackingEvent(
          this.buildMobileNavV2Category('general'),
          this.buildMobileNavV2EventLabel('search')
        );
      },
      true
    );
  }

  getSectionWrapperForElement(element) {
    if (!element || typeof element.closest !== 'function') {
      return null;
    }
    return element.closest('#shopify-section-header-v2');
  }

  getActiveSectionWrapper(element = null) {
    const sectionFromElement = this.getSectionWrapperForElement(element);
    if (sectionFromElement) {
      return sectionFromElement;
    }

    return document.querySelector('#shopify-section-header-v2');
  }

  getActiveHeaderSection(element = null) {
    const sectionWrapper = this.getActiveSectionWrapper(element);
    const headerFromSection =
      sectionWrapper?.querySelector('header[data-header-section]');
    if (headerFromSection) {
      return headerFromSection;
    }

    const headerFromElement = element?.closest?.('header[data-header-section]');
    if (headerFromElement) {
      return headerFromElement;
    }

    const headerFromPreferredSection = document.querySelector(
      '#shopify-section-header-v2 header[data-header-section]'
    );

    if (headerFromPreferredSection) {
      return headerFromPreferredSection;
    }

    return document.querySelector('header[data-header-section]');
  }

  getActiveNavScope(element = null) {
    return this.getActiveSectionWrapper(element) || document;
  }

  getActiveNavWrapper(element = null) {
    const activeSectionWrapper = this.getActiveSectionWrapper(element);
    const wrapperFromActiveSection = activeSectionWrapper?.querySelector(
      '.nav-main__wrapper'
    );

    return (
      wrapperFromActiveSection ||
      document.querySelector('.nav-main__wrapper.active') ||
      document.querySelector('.nav-main__wrapper')
    );
  }

  getActiveOpenToggle(element = null) {
    const triggerOpenToggle = element?.closest?.('.nav-main__toggle-btn--open');
    if (triggerOpenToggle) {
      return triggerOpenToggle;
    }

    const activeSectionWrapper = this.getActiveSectionWrapper(element);

    return (
      activeSectionWrapper?.querySelector('.nav-main__toggle-btn--open') ||
      document.querySelector('.nav-main__toggle-btn--open')
    );
  }

  setTopPosition(navWrapper = null) {
    const activeNavWrapper = navWrapper || this.getActiveNavWrapper();
    if (!activeNavWrapper) {
      return;
    }

    const $_breakpoint = document.querySelector(
      '#shopify-section-gld_promotion-bar'
    );
    const top = $_breakpoint ? $_breakpoint.offsetHeight : 0;
    activeNavWrapper.style.top = `${top}px`;
    activeNavWrapper.style.height = `calc(100% - ${top}px)`;
  }

  setNavLoclStorage() {
    const nav = localStorage.getItem('gender');
    if (nav) {
      this.setSpecialNav(nav);
    }
  }

  toggleNav() {
    const $_btn_open = document.querySelectorAll('.nav-main__toggle-btn--open');
    const $_btn_close = document.querySelectorAll(
      '.nav-main__toggle-btn--close, .js-mm-mobile-header-close'
    );

    if ($_btn_open.length) {
      $_btn_open.forEach((openButton) => {
        openButton.addEventListener('click', (e) => {
          const sectionWrapper = this.getSectionWrapperForElement(
            e.currentTarget
          );
          if (sectionWrapper) {
            sectionWrapper.classList.add('position--static--important');
          }
          this.openNav(e.currentTarget);
        });
      });
    }

    if ($_btn_close.length) {
      $_btn_close.forEach((closeButton) => {
        closeButton.addEventListener('click', (e) => {
          const sectionWrapper = this.getSectionWrapperForElement(
            e.currentTarget
          );
          if (sectionWrapper) {
            sectionWrapper.classList.remove('position--static--important');
          }
          this.closeNav(e.currentTarget);
        });
      });
    }

    document.addEventListener(
      'click',
      (event) => {
        if (
          !this.isDesktopSidebarNavActive() ||
          !document.body.classList.contains('nav-open')
        ) {
          return;
        }

        const target = event.target;
        const activeWrapper = this.getActiveNavWrapper(target);

        if (
          !activeWrapper ||
          !activeWrapper.classList.contains('active') ||
          activeWrapper.contains(target) ||
          target?.closest?.('.nav-main__toggle-btn')
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        this.closeNav(target);
      },
      true
    );
  }

  toggleNavSpecial() {
    const $_btn = document.querySelector('.header-main__sex');
    if ($_btn) {
      $_btn.addEventListener('click', (e) => {
        const { nav, href } = e.target.closest(
          '.header-main__sex__item'
        ).dataset;
        if (nav) {
          localStorage.setItem('gender', nav);
          window.location.href = href;
        }
      });
    }
  }

  setSpecialNav(nav) {
    [...document.querySelectorAll('.header-main__sex__item')].forEach(
      (item) => {
        if (item.dataset.nav !== nav) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      }
    );

    [...document.querySelectorAll('.header-main__bottom .site-nav')].forEach(
      (nav_item) => {
        if (nav_item.dataset.nav === nav) {
          nav_item.classList.add('site-nav--active');
        } else {
          nav_item.classList.remove('site-nav--active');
        }
      }
    );
  }

  handleClickCloseButton() {
    const $_btn = document.querySelectorAll('.nav-main__btn-close');
    if ($_btn.length) {
      $_btn.forEach((closeButton) => {
        closeButton.addEventListener('click', (event) => {
          this.closeNav(event.currentTarget);
        });
      });
    }
  }

  closeNav(triggerElement = null) {
    const navWrapper = this.getActiveNavWrapper(triggerElement);
    const shouldTrackMobileV2Close =
      this.isNewNavV2Active() && navWrapper?.classList.contains('active');
    if (shouldTrackMobileV2Close) {
      this.sendTrackingEvent(
        this.buildMobileNavV2Category('general'),
        this.buildMobileNavV2EventLabel('hamburger-closed')
      );
    }

    this.state = 'close';
    const activeSearchContainer = document.querySelector(
      '.search-module__container.search-module__container--active'
    );
    if (activeSearchContainer) {
      const searchCloseButton = document.querySelector(
        '.search-module__form__close'
      );
      if (searchCloseButton) {
        searchCloseButton.click();
      } else {
        activeSearchContainer.classList.remove('search-module__container--active');
        document
          .querySelectorAll('#shopify-section-header-v2')
          .forEach((sectionWrapper) => {
            sectionWrapper.classList.remove('search-module--active');
          });
      }
    }

    document.body.classList.remove('new-nav-mobile-search-overlay-active');
    document.documentElement.classList.remove(
      'new-nav-mobile-search-overlay-active'
    );
    if (this.isNewNavV2Active()) {
      const navScope = this.getActiveNavScope(triggerElement);
      const mobileNewNavInput =
        navScope.querySelector(
          '.js-mm-mobile-new-search-input'
        ) || document.querySelector('.js-mm-mobile-new-search-input');
      if (mobileNewNavInput) {
        mobileNewNavInput.value = '';
      }

      window.dispatchEvent(new Event('new-nav-search-reset'));
    }
    this.sendStats(
      'send',
      'event',
      'New Navigation',
      'Click',
      'Close Hamburger'
    );
    const openToggle = this.getActiveOpenToggle(triggerElement);

    const sectionWrapperFromTrigger =
      this.getSectionWrapperForElement(triggerElement);
    if (sectionWrapperFromTrigger) {
      sectionWrapperFromTrigger.classList.remove('position--static--important');
    } else {
      document
        .querySelectorAll('#shopify-section-header-v2')
        .forEach((sectionWrapper) => {
          sectionWrapper.classList.remove('position--static--important');
        });
    }

    General.bodyOverflowHiddenController('main-nav', false, false);
    if (navWrapper) {
      navWrapper.classList.remove('active');
    }
    document.querySelector('body').classList.remove('overflow--hidden');
    document.querySelector('body').classList.remove('nav-open');
    if (openToggle) {
      openToggle.classList.remove('active');
    }
    document
      .querySelectorAll('.nav-main__toggle-btn--open.active')
      .forEach((toggleButton) => {
        if (toggleButton !== openToggle) {
          toggleButton.classList.remove('active');
        }
      });

    this.resetMobileViewState(triggerElement);
  }

  openNav(triggerElement = null) {
    const navWrapper = this.getActiveNavWrapper(triggerElement);
    if (!navWrapper) {
      return;
    }

    if (this.isNewNavV2Active()) {
      this.sendTrackingEvent(
        this.buildMobileNavV2Category('general'),
        this.buildMobileNavV2EventLabel('hamburger-open')
      );
    }

    this.state = 'open';
    this.resetMobileViewState(triggerElement);
    this.setTopPosition(navWrapper);
    this.sendStats(
      'send',
      'event',
      'New Navigation',
      'Click',
      'Open Hamburger'
    );

    setTimeout(() => {
      General.bodyOverflowHiddenController('main-nav', true, false);
      navWrapper.classList.add('active');
      document.querySelector('body').classList.add('overflow--hidden');
      document.querySelector('body').classList.add('nav-open');
      const openToggle = this.getActiveOpenToggle(triggerElement);
      if (openToggle) {
        openToggle.classList.add('active');
      }
      if (!this.listenerOpenTab) {
        this.listenerFunctionOpenTab();
      }
      window.requestAnimationFrame(() => {
        this.syncMobileNewNavHeaderState(triggerElement);
      });
    }, 100);
  }

  listenerFunctionOpenTab() {
    document.addEventListener(
      'bodyOverflowHiddenController',
      () => {
        let overflowModules = [];
        try {
          overflowModules =
            JSON.parse(sessionStorage.getItem('overflow_hidden_modules')) || [];
        } catch (error) {
          overflowModules = [];
        }

        const keepOpenForNewNavSearchOverlay = document.body.classList.contains(
          'new-nav-mobile-search-overlay-active'
        );

        if (
          overflowModules.includes('main-nav') &&
          overflowModules.length > 1 &&
          this.state === 'open' &&
          !keepOpenForNewNavSearchOverlay
        ) {
          this.closeNav();
        }
      },
      false
    );
    this.listenerOpenTab = true;
  }

  handleClickWrapper() {
    const wrappers = document.querySelectorAll('.nav-main__wrapper');
    if (wrappers.length) {
      wrappers.forEach((wrapper) => {
        wrapper.addEventListener('click', (e) => {
          if (e.target === wrapper && wrapper.classList.contains('active')) {
            this.closeNav(wrapper);
          }
        });
      });
    }
  }

  progressBarMobileSiteNav() {
    const nav =
      document.querySelector(
        '.header-nav-variant--active .site-nav.site-nav--mobile'
      ) || document.querySelector('.site-nav.site-nav--mobile');
    if (!nav) {
      return;
    }
    nav.classList.add('site-nav--progressbar');
    const items = [...nav.children];
    let arrow = false;

    let value_total = 0;
    items.forEach((item) => (value_total += item.offsetWidth));
    value_total -= window.outerWidth;
    const setValue = (event) => {
      const value_current = event.target.scrollLeft;
      let value_percent = Math.ceil((value_current * 100) / value_total);
      if (value_percent > 100) {
        value_percent = 100;
      }
      setProgressbar(value_percent);
      if (arrow) {
        setArrow(value_percent);
      }
    };

    const setProgressbar = (value) => {
      const progressbar_value_element = document.querySelector(
        '.site-nav__progressbar__value'
      );
      if (progressbar_value_element) {
        progressbar_value_element.style.width = `${value}%`;
      }
    };

    const setArrow = General.debounce((value) => {
      const hide_arrow = arrow.classList.contains('site-nav__arrow--hide');
      if (value > 90 && !hide_arrow) {
        arrow.classList.add('site-nav__arrow--hide');
      } else if (value <= 90 && hide_arrow) {
        arrow.classList.remove('site-nav__arrow--hide');
      }
    }, 500);

    if (nav) {
      nav.addEventListener('scroll', (event) => setValue(event));
      nav.insertAdjacentHTML(
        'afterend',
        '<div class="site-nav__progressbar"><div class="site-nav__progressbar__value"></div></div>'
      );
      nav.insertAdjacentHTML(
        'afterend',
        '<div class="site-nav__arrow"><svg aria-hidden="true" class="icon icon-chevron-right" focusable="false" role="presentation" viewBox="0 0 14 14"><path d="M3.871.604c.44-.439 1.152-.439 1.591 0l5.515 5.515s-.049-.049.003.004l.082.08c.439.44.44 1.153 0 1.592l-5.6 5.6a1.125 1.125 0 0 1-1.59-1.59L8.675 7 3.87 2.195a1.125 1.125 0 0 1 0-1.59z" fill="#fff"></path></svg></div>'
      );
      arrow = document.querySelector('.site-nav__arrow');

      arrow.addEventListener('click', () => {
        let value_px = Math.ceil((value_total * 20) / 100);
        nav.scrollLeft += value_px;
      });
    }
  }

  bindMobileNewNavHeader() {
    const headerBackButtons = document.querySelectorAll('.js-mm-mobile-header-back');
    if (!headerBackButtons.length) {
      return;
    }

    headerBackButtons.forEach((headerBack) => {
      headerBack.addEventListener('click', (e) => {
        e.preventDefault();
        const currentLevel = this.getMobileCurrentLevel(headerBack);

        if (currentLevel <= 1) {
          return;
        }

        const activeSubview = this.getActiveMobileSubview(currentLevel, headerBack);
        const legacyBackButton = activeSubview?.querySelector(
          `.js-mm-mobile-dy-link-back[data-level="${currentLevel}"]`
        );

        if (legacyBackButton) {
          legacyBackButton.click();
          return;
        }

        this.moveViewToLevel(currentLevel - 1, headerBack);
      });
    });

    this.syncMobileNewNavHeaderState();
  }

  getMobileCurrentLevel(contextElement = null) {
    const navScope = this.getActiveNavScope(contextElement);
    const view =
      navScope.querySelector('.js-mm-mobile-dy-view') ||
      document.querySelector('.js-mm-mobile-dy-view');

    if (!view) {
      return 1;
    }

    return parseInt(view.dataset.currentLevel || '1', 10);
  }

  getActiveMobileSubview(level, contextElement = null) {
    const navScope = this.getActiveNavScope(contextElement);
    const visibleSubviews = navScope
      ? [
          ...navScope.querySelectorAll(
            '.js-mm-mobile-dy-subview:not(.is-hidden)'
          ),
        ]
      : [...document.querySelectorAll('.js-mm-mobile-dy-subview:not(.is-hidden)')];
    const matchingSubviews = visibleSubviews.filter((subview) => {
      const ownBackButton = [...subview.children].find(
        (child) =>
          child.classList?.contains('js-mm-mobile-dy-link-back') &&
          child.dataset?.level === `${level}`
      );

      return Boolean(ownBackButton);
    });

    return matchingSubviews[matchingSubviews.length - 1] || null;
  }

  getDirectMobileSubview(menuItem) {
    if (!menuItem || !menuItem.children) {
      return null;
    }

    return (
      [...menuItem.children].find(
        (child) => child.classList?.contains('js-mm-mobile-dy-subview')
      ) || null
    );
  }

  clearMobileLevel3BranchState(navScope = null) {
    const scope = navScope || document;
    scope
      .querySelectorAll('.js-mm-mobile-dy-subview.has-active-level3')
      .forEach((subview) => {
        subview.classList.remove('has-active-level3');
      });
    scope
      .querySelectorAll('.main-menu-mobile-nav__item.is-level3-branch')
      .forEach((item) => {
        item.classList.remove('is-level3-branch');
      });
    scope
      .querySelectorAll('.js-mm-mobile-dy-subview.is-active-level3')
      .forEach((subview) => {
        subview.classList.remove('is-active-level3');
      });
  }

  clearPendingMobileLevel3BranchState(navScope = null) {
    const scope = navScope || document;
    const pendingState = this.mobileLevel3PendingByScope.get(scope);
    if (!pendingState) {
      return;
    }

    const { view, onTransitionEnd, timeoutId } = pendingState;
    if (view && onTransitionEnd) {
      view.removeEventListener('transitionend', onTransitionEnd);
    }
    if (timeoutId) {
      window.clearTimeout(timeoutId);
    }

    this.mobileLevel3PendingByScope.delete(scope);
  }

  setMobileLevel3BranchState(targetSubview, contextElement = null) {
    if (!targetSubview) {
      return;
    }

    const navScope = this.getActiveNavScope(contextElement);
    this.clearMobileLevel3BranchState(navScope);

    const branchItem = targetSubview.parentElement;
    const parentSubview = branchItem?.closest('.js-mm-mobile-dy-subview');

    if (parentSubview) {
      parentSubview.classList.add('has-active-level3');
    }

    if (branchItem?.classList?.contains('main-menu-mobile-nav__item')) {
      branchItem.classList.add('is-level3-branch');
    }

    targetSubview.classList.add('is-active-level3');
  }

  setMobileLevel3BranchStateAfterTransition(
    targetSubview,
    contextElement = null
  ) {
    if (!targetSubview) {
      return;
    }

    const navScope = this.getActiveNavScope(contextElement);
    const view =
      navScope.querySelector('.js-mm-mobile-dy-view') ||
      document.querySelector('.js-mm-mobile-dy-view');

    if (!view) {
      this.setMobileLevel3BranchState(targetSubview, contextElement);
      return;
    }

    this.clearPendingMobileLevel3BranchState(navScope);

    const applyBranchState = () => {
      // Transition may have been canceled by fast back / close nav interactions.
      if (
        view.dataset.currentLevel !== '3' ||
        targetSubview.classList.contains('is-hidden')
      ) {
        return;
      }

      this.setMobileLevel3BranchState(targetSubview, contextElement);
    };

    const finishPendingState = () => {
      this.clearPendingMobileLevel3BranchState(navScope);
      applyBranchState();
    };

    const onTransitionEnd = (event) => {
      if (event.target !== view || event.propertyName !== 'transform') {
        return;
      }
      finishPendingState();
    };

    view.addEventListener('transitionend', onTransitionEnd);

    const timeoutId = window.setTimeout(() => {
      finishPendingState();
    }, 380);

    this.mobileLevel3PendingByScope.set(navScope, {
      view,
      onTransitionEnd,
      timeoutId,
    });
  }

  resetMobileViewState(contextElement = null) {
    const navScope = this.getActiveNavScope(contextElement);
    if (!navScope) {
      return;
    }

    const view = navScope.querySelector('.js-mm-mobile-dy-view');
    if (view) {
      view.dataset.currentLevel = '1';
    }

    const container = navScope.querySelector(
      '.main-menu-mobile-nav-container'
    );
    if (container) {
      container.dataset.mobileCurrentLevel = '1';
    }

    this.clearPendingMobileLevel3BranchState(navScope);
    this.clearMobileLevel3BranchState(navScope);

    navScope
      .querySelectorAll('.js-mm-mobile-dy-subview')
      .forEach((subview) => {
        subview.classList.add('is-hidden');
      });

    const scrollArea = navScope.querySelector(
      '.js-mm-mobile-dy-scrollarea'
    );
    if (scrollArea) {
      scrollArea.scrollTo({
        top: 0,
        behavior: 'auto',
      });
    }

    this.syncMobileNewNavHeaderState(contextElement);
  }

  syncMobileNewNavHeaderState(contextElement = null) {
    const navScope = this.getActiveNavScope(contextElement);
    if (!navScope) {
      return;
    }

    const container = navScope.querySelector(
      '.main-menu-mobile-nav-container'
    );
    const headerBackLabel = navScope.querySelector(
      '.js-mm-mobile-header-back-label'
    );
    const headerTitle = navScope.querySelector(
      '.js-mm-mobile-header-title'
    );
    const level = this.getMobileCurrentLevel(contextElement);

    if (container) {
      container.dataset.mobileCurrentLevel = `${level}`;
    }

    if (!headerBackLabel || !headerTitle) {
      return;
    }

    if (level <= 1) {
      headerBackLabel.textContent = 'All';
      headerTitle.textContent = '';
      headerTitle.classList.remove('main-menu-mobile-nav__new-title--compact');
      return;
    }

    const activeSubview = this.getActiveMobileSubview(level, contextElement);
    const legacyBackLabel = activeSubview?.querySelector(
      `.js-mm-mobile-dy-link-back[data-level="${level}"] span:last-child`
    );
    const legacyTitle = activeSubview?.querySelector('.main-menu-mobile-nav__title');

    const nextBackLabel = legacyBackLabel?.textContent?.trim() || 'All';
    const nextHeaderTitle = legacyTitle?.textContent?.trim() || '';

    headerBackLabel.textContent = nextBackLabel;
    headerTitle.textContent = nextHeaderTitle;
    headerTitle.classList.toggle(
      'main-menu-mobile-nav__new-title--compact',
      nextHeaderTitle.length > 20
    );
  }

  bindKeyboardDropdown() {
    const dropdownItems = document.querySelectorAll(
      '.site-nav .site-nav__item[aria-haspopup=true]'
    );

    dropdownItems.forEach((item) => {
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();

          const isOpen = item.classList.contains('is-active');

          dropdownItems.forEach((otherItem) => {
            otherItem.classList.remove('is-active');
            otherItem.setAttribute('aria-expanded', 'false');
          });

          if (!isOpen) {
            item.classList.add('is-active');
            item.setAttribute('aria-expanded', 'true');
          }
        }

        if (e.key === 'Escape') {
          item.classList.remove('is-active');
          item.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  bindKeyboardSiteNavLinks() {
    const siteNavLinks = document.querySelectorAll(
      '.site-nav__level--2 .site-nav__link'
    );
    siteNavLinks.forEach((link) => {
      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          link.click();
        }
      });
    });
  }

  bindViewEvents() {
    const menuItems = document.querySelectorAll('.js-mm-mobile-dy-link-view');

    menuItems.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const targetLevel = parseInt(link.dataset.level, 10) + 1;
        if (Number.isNaN(targetLevel)) {
          return;
        }

        const navScope = this.getActiveNavScope(link);
        const parentItem = link.parentElement;
        const targetSubview = this.getDirectMobileSubview(parentItem);
        const parentList = parentItem?.parentElement;

        // Keep only one opened subview per sibling set to avoid stacked level views.
        if (parentList) {
          [...parentList.children].forEach((siblingItem) => {
            if (siblingItem === parentItem) {
              return;
            }

            const siblingSubview = this.getDirectMobileSubview(siblingItem);
            if (siblingSubview) {
              siblingSubview.classList.add('is-hidden');
            }
          });
        }

        if (targetLevel < 3) {
          this.clearPendingMobileLevel3BranchState(navScope);
          this.clearMobileLevel3BranchState(navScope);
        }

        if (targetSubview) {
          targetSubview.classList.remove('is-hidden');
          if (targetLevel === 3) {
            this.setMobileLevel3BranchStateAfterTransition(targetSubview, link);
          }
        }
        this.moveViewToLevel(targetLevel, link);
      });
    });

    const menuItemsBack = document.querySelectorAll(
      '.js-mm-mobile-dy-link-back'
    );

    menuItemsBack.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const targetLevel = parseInt(link.dataset.level, 10) - 1;
        if (Number.isNaN(targetLevel)) {
          return;
        }

        if (targetLevel < 3) {
          const navScope = this.getActiveNavScope(link);
          this.clearPendingMobileLevel3BranchState(navScope);
          this.clearMobileLevel3BranchState(navScope);
        }

        this.moveViewToLevel(targetLevel, link);
        setTimeout(() => {
          if (link.parentElement?.classList?.contains('js-mm-mobile-dy-subview')) {
            link.parentElement.classList.add('is-hidden');
          }
        }, 700);
      });
    });

  }

  moveViewToLevel(level, contextElement = null) {
    const navScope = this.getActiveNavScope(contextElement);
    const view =
      navScope.querySelector('.js-mm-mobile-dy-view') ||
      document.querySelector('.js-mm-mobile-dy-view');

    if (view) {
      view.dataset.currentLevel = level;
    }

    const container =
      navScope.querySelector('.main-menu-mobile-nav-container') ||
      document.querySelector('.main-menu-mobile-nav-container');
    if (container) {
      container.dataset.mobileCurrentLevel = `${level}`;
    }

    const scrollArea =
      navScope.querySelector('.js-mm-mobile-dy-scrollarea') ||
      document.querySelector('.js-mm-mobile-dy-scrollarea');
    if (scrollArea) {
      scrollArea.scrollTo({
        top: 0,
        behavior: 'auto',
      });
    }

    this.syncMobileNewNavHeaderState(contextElement);
  }
}
